import React, {Component} from 'react';
import {Alert, Table} from 'reactstrap';
import {_getRequestAcc, _requestAcc} from '../../../../../services/apis/AdminAffiliate';
import ItemRequest from './ItemRequest';
import Pages from '../pagination/Pages';
import {changeQuerySearch, parseSearchQuery} from "../../../../../helpers/routes/RouterHelper"

const getInitPage = () =>{
    const parsed = parseSearchQuery();
    return !!parsed.page ? parseInt(parsed.page, 10) : 1;
}

class RequestAccPage extends Component {
    state = {
        listRequest: [],
        error: '',
        total: 0,
        pages: {
            page: getInitPage(),
            limit: 10,
            maxPage: 1
        }
    }

    componentDidMount() {
        this.getRequestAcc();
    }

    componentDidUpdate(preProps, preState) {
        const {page} = this.state.pages;
        if (preState.pages.page !== page) {
            this.getRequestAcc();
        }
    }

    getRequestAcc = () => {
        const {page, limit} = this.state.pages;

        _getRequestAcc(page, limit)
            .then((result) => {
                if (result.success) {
                    this.setState({
                        listRequest: result.data.docs,
                        error: '',
                        maxPage: result.data.pages,
                        total: result.data.total,
                        pages: {
                            page: result.data.page,
                            limit: 10,
                            maxPage: result.data.pages
                        }
                    });
                } else {
                    this.setState({
                        error: result.message
                    });
                }
            })
            .catch((error) => {
                this.setState({
                    error: error.message
                });
            });
    }

    handleClick = (request, status) => () => {
        const {listRequest} = this.state;
        const id = request['_id'];

        _requestAcc(id, status)
            .then((result) => {
                if (result.success) {
                    const newRequest = listRequest.map(ItemRequest => {
                        if (ItemRequest['_id'] === request['_id']) {
                            request.status = status;
                            return request;
                        }
                        return ItemRequest;
                    });

                    this.setState({
                        listRequest: newRequest,
                        error: ''
                    })
                } else {
                    this.setState({
                        error: result.message
                    });
                }
            })
            .catch((error) => {
                this.setState({
                    error: error.message
                });
            });
    }

    handleGoToPage = (index) => {
        const {limit, maxPage} = this.state.pages;
        changeQuerySearch({page: index});
        this.setState({
            pages: {
                page: index,
                limit,
                maxPage
            }
        })
    }

    render() {
        const {listRequest, error, pages, total} = this.state;

        return (
            <div className="RequestAccPage">
                {
                    !!error ? <Alert color="danger">{error}</Alert> : ''
                }
                <h2>Request({total})</h2>
                <Table>
                    <thead>
                    <tr>
                        <th>NAME</th>
                        <th>EMAIL</th>
                        <th>CREATED</th>
                        <th>STATUS</th>
                        <th>ACTION</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        listRequest.map((requestAcc, index) => {
                            return (
                                <ItemRequest
                                    key={index}
                                    requestAcc={requestAcc}
                                    handleClick={this.handleClick}
                                />
                            );
                        })
                    }
                    </tbody>
                </Table>

                <Pages
                    pages={pages}
                    handleGoToPage={this.handleGoToPage}
                />
            </div>
        );
    }
}

export default RequestAccPage;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/affiliate/request-acc/RequestAccPage.js